/**
 * The organization code rule, mirroring the API (`validateOrganizationCode`) and
 * the `organizations.code_format` constraint (migration 248): lowercase letters,
 * digits and `_`, with `-` allowed in the interior only (never first or last),
 * 3 to 50 characters.
 */
export const ORGANIZATION_CODE_RE = /^[a-z0-9_]([a-z0-9_-]*[a-z0-9_])?$/
export const ORGANIZATION_CODE_MIN = 3
export const ORGANIZATION_CODE_MAX = 50

export function isValidOrganizationCodeFormat(code: string): boolean {
  return ORGANIZATION_CODE_RE.test(code)
}

export function isValidOrganizationCodeLength(code: string): boolean {
  return code.length >= ORGANIZATION_CODE_MIN && code.length <= ORGANIZATION_CODE_MAX
}

/**
 * Proposes a code from an organization name: accents dropped, lowercase, every
 * run of other characters turned into one `-`, no `-` at either end, cut to the
 * maximum length. The result may still be too short; the form validates it.
 */
export function suggestOrganizationCode(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9_]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, ORGANIZATION_CODE_MAX)
    .replace(/-+$/, '')
}
